export function sortByNameCategoryData(arr: any[]): any[] {
  return arr
    .map(category => ({
      ...category,
      sub_category_data: category.sub_category_data
        .map((sub:any) => ({
          ...sub,
          item_data: (sub.item_data || []).sort((a: any, b: any) => {
            const nameA = a?.name ?? '';
            const nameB = b?.name ?? '';
            return nameA.localeCompare(nameB);
          })
        }))
        .sort((a: any, b: any) => {
          const nameA = a?.name ?? '';
          const nameB = b?.name ?? '';
          return nameA.localeCompare(nameB);
        })
    }))
    // .sort((a: any, b: any) => {
    //   const nameA = a?.name ?? '';
    //   const nameB = b?.name ?? '';
    //   return nameA.localeCompare(nameB);
    // });
}
